import { render, staticRenderFns } from "./FormatPropertyLimitEditTool.vue?vue&type=template&id=0dc16cb8&scoped=true&"
import script from "./FormatPropertyLimitEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatPropertyLimitEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPropertyLimitEditTool.vue?vue&type=style&index=0&id=0dc16cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc16cb8",
  null
  
)

export default component.exports